import { z } from 'zod'

export type SparklineData = z.infer<typeof SparklineData>;
export const SparklineData = z.object({
  data: z.number().array(),
  /**
   * The termCodes that the `data` field correspond to.
   * All sparklines in CougarGrades have the same domain (set of possible x-values).
   * The domain is generated by the earliest semester available and the latest semester available.
   */
  xAxis: z.number().array(),
  /**
   * This is the range (set of possible y-values).
   * This is different depending on the data.
   * For courses, the upper range is the max value that a course had enrollment in a single semester.
   * For instructors, the upper range is the max value that a instructors had enrollment in a single semester.
   * The lower range for both is (presumably) zero.
   */
  yAxis: z.object({
    min: z.number(),
    max: z.number(),
    avg: z.number(),
    stddev: z.number(),
    median: z.number(),
  })
});

export type BinnedSparklineData = z.infer<typeof BinnedSparklineData>;
export const BinnedSparklineData = SparklineData.extend({
  /**
   * Each point represents a time range
   */
  xAxis: z.string().array(),
  /**
   * This is the range (set of possible y-values).
   * This is different depending on the data.
   * For courses, the upper range is the max value that a course had enrollment in a single semester.
   * For instructors, the upper range is the max value that a instructors had enrollment in a single semester.
   * The lower range for both is (presumably) zero.
   */
  yAxis: z.object({
    // Typically, 0
    min: z.number(),
    // Depends on what is being measured
    max: z.number(),
  })
})
